export default {
  title: 'Fast pay',

  labels: {
    amount: 'Amount',
    method: 'Method'
  },

  methods: {
    v1: {
      tinkoff: 'Tinkoff'
    }
  },

  hints: {
    commission: 'Bank fee: 3%',
    commissions: 'Fee'
  },

  errors: {
    amount: 'For payment, the link must contain a valid amount.',
    method: 'For payment, the link must contain a valid payment method.',
    owner: 'For payment, the link must contain the owner\'s ID.'
  }
}
